import { parseBaseModel, stripBaseFields } from "./BaseModel";

const STUDIO_FORM_FIELDS = [
  "type",
  "locale",
  "formId",
  "name",
  "description",
  "formName",
  "shortName",
  "revisions",
  "version",
  "published",
];

/**
 * Parses an API response into a StudioForm object with base model fields.
 *
 * @param {Object} json - Raw API response JSON
 * @returns {Object} StudioForm fields + base model fields (id, createdAt, etc.)
 */
export const parseStudioForm = (json) => {
  if (!json) return {};

  const base = parseBaseModel(json);
  const domain = stripBaseFields(json);

  return {
    ...base,
    type: domain.type || "",
    locale: domain.locale || "",
    formId: domain.formId || "",
    name: domain.name || "",
    description: domain.description || "",
    formName: domain.formName || "",
    shortName: domain.shortName || "",
    revisions: domain.revisions ?? 0,
    version: domain.version || "",
    published: domain.published || [],
    annotationsCompleted: domain.annotationsCompleted ?? null,
    annotationsCompletedBy: domain.annotationsCompletedBy ?? null,
    annotationsCompletedByUserProfile: domain.annotationsCompletedByUserProfile ?? null,
    jsonCompleted: domain.jsonCompleted ?? null,
    jsonCompletedBy: domain.jsonCompletedBy ?? null,
    jsonCompletedByUserProfile: domain.jsonCompletedByUserProfile ?? null,
  };
};

/**
 * Parses an API response containing an array of StudioForm objects.
 *
 * @param {Array} jsonArray - Raw API response JSON array
 * @returns {Array} Array of parsed StudioForm objects
 */
export const parseStudioFormList = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];
  return jsonArray.map(parseStudioForm);
};

export default {
  STUDIO_FORM_FIELDS,
  parseStudioForm,
  parseStudioFormList,
};
